import { render, staticRenderFns } from "./PurchaseHistoryManager.vue?vue&type=template&id=604f3da5&"
import script from "./PurchaseHistoryManager.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistoryManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseHistoryManager.vue"
export default component.exports